var _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.149,
    height: 15.149,
    viewBox: "0 0 15.149 15.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.575,0a7.575,7.575,0,1,0,7.575,7.575A7.57,7.57,0,0,0,7.575,0Zm0,13.966a6.391,6.391,0,1,1,6.391-6.391A6.388,6.388,0,0,1,7.575,13.966Z",
    fill: "#052eb4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.983 6.342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.592,214.33a.592.592,0,0,0-.592.592v3.811a.592.592,0,1,0,1.184,0v-3.811A.592.592,0,0,0,236.592,214.33Z",
    transform: "translate(-236 -214.33)",
    fill: "#052eb4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.776 4.019)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.799,
    cy: 0.799,
    r: 0.799,
    fill: "#052eb4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.6da5cc4b.svg";
export { ForwardRef as ReactComponent };